<template>
  <li>
    <router-link v-if="!disableLink" :to="{ name: 'loads.show', params: { id: item.load.id } }">
      {{ item.load.reference_number }}
    </router-link>
    <a v-else href="#">{{ item.load.reference_number }}</a>

    <div class="row m-t-sm">
      <div class="col-xs-12">
          {{ item.description }} <br>
          <p class="muted small">
            <!-- based on commodity charge type -->
            <!-- either pickup or delivery -->
            Date: {{item.load[`${item.load.commodity_charge_type}_date`] || item.load.loading_date}} | Rego: {{item.load.truck.registration}}
          </p>
      </div>
      <div class="col-xs-12 col-sm-6">
        <b>Dockets:</b> <br>
        <div v-for="docket of item.load.weighbridge.dockets" :key="docket.id">
          {{ docket.number }}
        </div>
      </div>
      <div class="col-xs-4 col-sm-2">
        <span v-if="isPerTonneCharge(item) || isLoad(item)">
          {{ item.quantity }}t
        </span>
      </div>
      <div class="col-xs-4 col-sm-2">
        {{ costPerTonne }}
      </div>
      <div class="col-xs-4 col-sm-2 amount text-right">
        {{ cost }}
      </div>
    </div>

    <payment-item-charge v-for="charge in item.charges" :key="charge.id" :charge="charge"></payment-item-charge>
  </li>
</template>

<script>
  import PaymentItemCharge from './ShowPaymentItemCharge'
  import accounting from 'accounting'

  export default {
    props: ['item', 'disableLink'],

    components: {
      PaymentItemCharge
    },

    computed: {
      costPerTonne () {
        return `${accounting.formatMoney(this.item.per_unit_cost)}/t`
      },

      cost () {
        return accounting.formatMoney(this.item.per_unit_cost * this.item.quantity)
      }
    },

    methods: {
      isLoad (item) {
        return item.type === 'load'
      },

      isPerTonneCharge (item) {
        return item.type === 'job' || item.type === 'charge_per_tonne'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ShowPaymentItem.vue?a40b6f9c